module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/dividers/divider-vertical-1-1563dd9a77bc25beea7c592449149c5e.svg";